import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Container, Spinner } from "reactstrap";
import CommunicationComponent from "../communication/CommunicationComponent";
import { FaCheck } from "react-icons/fa";

/**
 * Fortschrittsleiste ueber dem Formular.
 *
 * Sie zeigt drei Dinge gleichzeitig: wo man steht (hervorgehobener Schritt und
 * gefuellte Schiene), was erledigt ist (Haken statt Nummer) und was noch kommt
 * (die restlichen Schritte bleiben sichtbar, nur zurueckgenommen).
 */
class MainNavigation extends CommunicationComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    qCtrl() {
        return this.props.qctrl;
    }

    clickOnMainCategory(e, c) {
        this.fireEvent("pageChanged");
        this.qCtrl().setCurrentMainCategory(c);
    }

    getSteps() {
        return this.qCtrl().getAllCategories()
          .filter((c) => this.qCtrl().hasSubcategories(c));
    }

    getCurrentIndex(steps) {
        const current = this.qCtrl().getCurrentCategory();
        if (!current) {
            return 0;
        }
        const index = steps.findIndex((c) => c.id == current.id);
        return index < 0 ? 0 : index;
    }

    renderStep(c, index, currentIndex) {
        const finished = this.qCtrl().isMainCategoryFinished(c);
        // Klickbar bleibt wie gehabt isClickable(); als klickbar markiert wird
        // ein Schritt wie frueher nur, wenn er erledigt ist oder der
        // Kategoriemodus laeuft.
        const clickable = this.qCtrl().isClickable(c);
        const showAsClickable = clickable &&
          (finished || this.qCtrl().isCategoryMode());

        let cls = "wc-step";
        if (index === currentIndex) {
            cls += " is-current";
        }
        else if (finished) {
            cls += " is-done";
        }
        else {
            cls += " is-upcoming";
        }
        if (showAsClickable) {
            cls += " is-clickable";
        }

        const onClick = (e) => (clickable) ? this.clickOnMainCategory(e, c) : null;

        return <li key={c.id} className={cls} onClick={onClick}>
            <span className={"wc-step-marker"}>
                {finished && index !== currentIndex
                  ? <FaCheck size={12} />
                  : c.id}
            </span>
            <span className={"wc-step-label"}>{c.name}</span>
        </li>;
    }

    render() {
        const steps = this.getSteps();
        const currentIndex = this.getCurrentIndex(steps);
        const doneCount = steps.filter((c) => this.qCtrl().isMainCategoryFinished(c)).length;

        // Die Schiene laeuft von Mitte des ersten bis Mitte des letzten Markers.
        const half = steps.length > 0 ? (50 / steps.length) + "%" : "0";
        const fill = steps.length > 1
          ? (currentIndex / (steps.length - 1)) * 100
          : 100;

        const showSave = !this.qCtrl().isFinished() || this.qCtrl().isEditMode();

        return <Container fluid={true} className={"mainnav"}>
            <div className={"wc-stepper"}>
                <div className={"wc-stepper-status"}>
                    <span className={"wc-stepper-position"}>
                        Schritt {currentIndex + 1} von {steps.length}
                    </span>
                    {doneCount > 0 && <span className={"wc-stepper-done"}>
                        {doneCount} erledigt
                    </span>}
                </div>

                <div className={"wc-stepper-track"}>
                    <div className={"wc-stepper-rail"} style={{left: half, right: half}}>
                        <div className={"wc-stepper-rail-fill"} style={{width: fill + "%"}} />
                    </div>
                    <ol className={"wc-steps"}>
                        {steps.map((c, i) => this.renderStep(c, i, currentIndex))}
                    </ol>
                    {/* zeigt auf den aktiven Schritt und verbindet ihn mit den
                        Unterpunkten darunter */}
                    {steps.length > 0 && <span
                      className={"wc-stepper-caret"}
                      style={{left: (((currentIndex + 0.5) / steps.length) * 100) + "%"}}
                    />}
                </div>

                {showSave && <div className={"wc-stepper-action"}>
                    <button onClick={() => this.qCtrl().saveQuestionsComplete()}
                            disabled={this.props.saved || this.props.saving}
                            className={"save-button mode-" + (this.props.saved ? "saved" : "unsaved")}>
                        {this.props.saving && <Spinner size={"sm"}/>} Speichern
                    </button>
                </div>}
            </div>
        </Container>;
    }
};

MainNavigation.propTypes = {};


export default MainNavigation;
